var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleForm',{attrs:{"onSubmit":_vm.onSubmit,"fields":[
		{
			label : 'First name',
			name : 'first_name',
			autofocus : true,
			required : true,
		},
		{
			label : 'Last name',
			name : 'last_name',
			required : true,
		},
		{
			label : 'Email',
			name : 'email',
			type : 'email',
			autocomplete : 'username',
			required : true,
		},
		{
			label : 'Organisation / Team name',
			name : !_vm.invite ? 'org_name' : null,
			required : !_vm.invite ,
		},
		{
			label : 'New Password',
			name : 'password',
			type : 'password',
			autocomplete : 'new-password',
			required : true,
		} ],"model":_vm.invite ? {
		first_name : _vm.invite.first_name,
		last_name : _vm.invite.last_name,
		email : _vm.invite.email,
	} : null,"submitText":"Agree & Create account"},scopedSlots:_vm._u([{key:"clickwrap",fn:function(){return [_vm._v("\n\t\tBy creating an account with us, you agree to our "),_c('a',{attrs:{"href":_vm.terms_url,"target":"_blank"}},[_vm._v("General Terms and Conditions")]),_vm._v(".\n\t")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }